import { IUser } from '../models/IUser'
import { makeAutoObservable } from 'mobx'
import AuthService from '../services/AuthService'
import axios, { AxiosError } from 'axios'
import { AuthResponse } from '../models/response/AuthResponse'
import { API_URL } from '../http'
import { message } from 'antd'

export default class AuthStore {
  user = {} as IUser
  isAuth = false
  isLoading = false

  constructor() {
    makeAutoObservable(this)
  }

  setAuth(bool: boolean) {
    this.isAuth = bool
  }

  setUser(user: IUser) {
    this.user = user
  }

  setLoading(bool: boolean) {
    this.isLoading = bool
  }

  async login(email: string, password: string) {
    try {
      const response = await AuthService.login(email, password)
      localStorage.setItem('RbkAccessToken', response.data.accessToken)
      this.setAuth(true)
      this.setUser(response.data.user)
      window.location.href = '/'
    } catch (e) {
      if ((e as AxiosError).response?.status === 500) {
        message.error((e as AxiosError).response?.data.detail)
      } else {
        console.log(e)
      }
    }
  }

  async registration(email: string, password: string, username: string) {
    try {
      const response = await AuthService.registration(email, password, username)
      localStorage.setItem('RbkAccessToken', response.data.accessToken)
      this.setAuth(true)
      this.setUser(response.data.user)
      window.location.href = '/'
    } catch (e) {
      if ((e as AxiosError).response?.status === 500) {
        message.error((e as AxiosError).response?.data.detail)
      } else {
        console.log(e)
      }
    }
  }

  async logout() {
    try {
      const response = await AuthService.logout()
      localStorage.removeItem('RbkAccessToken')
      this.setAuth(false)
      this.setUser({} as IUser)
      window.location.href = '/'
    } catch (e) {
      if ((e as AxiosError).response?.status === 500) {
        message.error((e as AxiosError).response?.data.detail)
      } else {
        console.log(e)
      }
    }
  }

  async checkAuth() {
    this.setLoading(true)
    try {
      const response = await axios.get<AuthResponse>(`${API_URL}auth/refresh`, {
        withCredentials: true,
      })
      localStorage.setItem('RbkAccessToken', response.data.accessToken)
      this.setAuth(true)
      this.setUser(response.data.user)
    } catch (e) {
      if ((e as AxiosError).response?.status === 500) {
        message.error((e as AxiosError).response?.data.detail)
      } else {
        console.log(e)
      }
    } finally {
      this.setLoading(false)
    }
  }
}
